var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDefaultPaymentMethod = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 46,
    viewBox: "0 0 66 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 46,
    rx: 6,
    fill: "#DDECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21H44M24 15H42C43.1046 15 44 15.8954 44 17V29C44 30.1046 43.1046 31 42 31H24C22.8954 31 22 30.1046 22 29V17C22 15.8954 22.8954 15 24 15Z",
    stroke: "#6B7DE5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDefaultPaymentMethod);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_default_payment_method.110b8810ee29ee769951fda16a505cfa.svg";